'use strict';
const createSVGDOM = require('./create-svg-dom'),
	attr = require('../dom/attr'),
	updateConnectorImpl = require('./update-connector'),
	updateLinkImpl = require('./update-link'),
	nodeWithIdImpl = require('./node-with-id'),
	updateNodeContentImpl = require('./update-node-content'),
	createReorderBounds = require('./create-reorder-bounds'),
	updateReorderBoundsImpl = require('./update-reorder-bounds'),
	hide = require('../dom/hide'),
	queueFadeOut = require('./queue-fade-out'),
	findLine = require('./find-line'),
	editNodeImpl = require('./edit-node'),
	updateNodeScreenCoordinatesImpl = require('./update-node-screen-coordinates');
module.exports = function DomMapView(stage) {
	if (!stage) {
		throw new Error('invalid-args');
	}
	const reorderBoundary = createReorderBounds(stage.getDOMElement()),
		createSVGGroup = function (attrs) {
			const domElement = createSVGDOM('g');
			attr(domElement, attrs);
			stage.getSVGContainer().appendChild(domElement);
			return domElement;
		},
		updateLink = (params) =>  updateLinkImpl(Object.assign({stage}, params)),
		updateConnector = (params) => updateConnectorImpl(Object.assign({stage}, params)),
		updateNodeContent = (node, nodeView) => {
			const domElement = nodeWithIdImpl(stage.getDOMElement(), node.id);
			stage.ensureSpaceForBox(node);
			updateNodeContentImpl(domElement, node, nodeView);
		},
		updateNodeScreenCoordinates = (node, nodeView) => {
			const domElement = nodeWithIdImpl(stage.getDOMElement(), node.id);
			stage.ensureSpaceForBox(node);
			updateNodeScreenCoordinatesImpl(domElement, node, nodeView);
		},
		updateReorderBounds = (border, box, dropCoords) => updateReorderBoundsImpl(reorderBoundary, border, box, dropCoords),
		hideReorderBounds = () => hide(reorderBoundary),
		nodeWithId = nodeId => nodeWithIdImpl(stage.getDOMElement(), nodeId),
		fadeOutNode = (nodeId, theme) => queueFadeOut(nodeWithIdImpl(stage.getDOMElement(), nodeId), theme),
		fadeOutConnector = (connector, theme) => queueFadeOut(findLine(connector, stage.getDOMElement()), theme),
		fadeOutLink = (link, theme) => queueFadeOut(findLine(link, stage.getDOMElement()), theme),
		editNode = (nodeId, layoutNode, selectAll) => editNodeImpl(stage.getDOMElement(), nodeWithIdImpl(stage.getDOMElement(), nodeId), layoutNode, selectAll);

	Object.freeze(Object.assign(this, {createSVGGroup, updateLink, updateConnector, updateNodeContent, updateNodeScreenCoordinates, updateReorderBounds, hideReorderBounds, nodeWithId, fadeOutNode, fadeOutConnector, fadeOutLink, editNode}));
};
